import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import HomePage from './pages/HomePage';
import EpisodesPage from './pages/EpisodesPage';
import EpisodesByTag from './pages/EpisodesByTag';
import ContactPage from './pages/ContactPage';
import EpisodePage from './pages/EpisodePage';
import { ThemeProvider } from './ThemeContext';

function App() {
  return (
    <HelmetProvider>
      <ThemeProvider>
        <Router>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/episodes" element={<EpisodesPage />} />
            <Route path="/episodes/tag/:tag" element={<EpisodesByTag />} />
            <Route path="/episode/:id" element={<EpisodePage />} />
            <Route path="/contact" element={<ContactPage />} />
          </Routes>
        </Router>
      </ThemeProvider>
    </HelmetProvider>
  );
}

export default App;
